;(function($){

  $(window).ready(init);

  function init() {
    var SLIDER_FIXED = '.SliderPage-container';
    var SLIDER_CONTENT = '.PackContent-slider';
    var SIDELEFT = '.PackContent-side--left';
    var SIDERIGHT = '.PackContent-side--right';
    var FOOTER = '.PackFooter';

    if($(SLIDER_FIXED).length > 0){
      function adjustSizes() {
        var WINDOWHEIGHT = $(window).height() - 80;
        var WINDOWWIDTH = $(window).width() - 160;
        $(SLIDER_FIXED).height(WINDOWHEIGHT);
        if(WINDOWWIDTH > 1400){
          $(SLIDER_FIXED).width(WINDOWWIDTH / 2);
        } else {
          $(SLIDER_FIXED).width(WINDOWWIDTH * 0.4);
        }

        $(SLIDER_CONTENT).height(WINDOWHEIGHT);
      }

      if($(window).width() > 992){
        adjustSizes();
      }

      $(window).on('resize', function(){
        var window = $(this).width();
        if(window > 992) {
          adjustSizes();
        }
      });

    } else {
      return
    }
  }

})(jQuery);
